import { createSlice } from '@reduxjs/toolkit';
import {
  fetchClientAlbum,
  fetchClientFolder,
  fetchClientFolders,
  updateClientFolder,
  fetchClientPhotos,
  fetchClientVideos,
  verifyAlbumPin,
  updateClientPhoto,
} from '../thunks/client';

const initialState = {
  album: {},
  folders: {},
  photos: {},
  videos: {},
  folder: {},
  meta: {},
  selectedTab: 'all',
  selectionFolder: {},
  isSelectedPhotosModalOpen: false,
  albumPin: null,
  folderPhotosCount: null,
  pageNumber: 1,
  perPage: 40,
  showFolderTabs: false,
  fetching: false,
  fetchError: '',
  saving: false,
  saveError: '',
};

export const clientSlice = createSlice({
  name: 'client',
  initialState,
  reducers: {
    setFolderTabs: (state) => {
      state.showFolderTabs = true;
    },
    setPhotosPageNumber: (state, action) => {
      state.pageNumber = action.payload;
    },
    setCurrentClientFolder: (state, action) => {
      state.folder = { ...state.folder, ...action.payload };
    },
    updateAlbumPin: (state, action) => {
      state.albumPin = action.payload;
    },
    openSelectedPhotosModal: (state, action) => {
      state.isSelectedPhotosModalOpen = action.payload;
    },
    updateSelectedPhotoCount: (state, action) => {
      if (action.payload === 'add') {
        state.selectionFolder.selected_photos_count++;
      } else {
        state.selectionFolder.selected_photos_count--;
      }
    },
    setSelectedTab: (state, action) => {
      state.selectedTab = action.payload;
    },
  },
  extraReducers: {
    [fetchClientAlbum.pending]: (state) => {
      state.fetching = true;
    },
    [fetchClientAlbum.fulfilled]: (state, action) => {
      state.fetching = false;
      state.album = action.payload;
    },
    [fetchClientAlbum.rejected]: (state, action) => {
      state.fetching = false;
      state.fetchError = action.payload.error;
    },
    [fetchClientFolder.pending]: (state) => {
      state.fetching = true;
    },
    [fetchClientFolder.fulfilled]: (state, action) => {
      state.fetching = false;
      state.selectionFolder = action.payload;
    },
    [fetchClientFolder.rejected]: (state, action) => {
      state.fetching = false;
      state.fetchError = action.payload.error;
    },
    [updateClientFolder.pending]: (state) => {
      state.fetching = true;
    },
    [updateClientFolder.fulfilled]: (state, action) => {
      state.fetching = false;
    },
    [updateClientFolder.rejected]: (state, action) => {
      state.fetching = false;
    },
    [fetchClientFolders.pending]: (state) => {
      state.fetching = true;
    },
    [fetchClientFolders.fulfilled]: (state, action) => {
      state.fetching = false;
      state.folders = action.payload;
      state.folder = state.folders[0];
    },
    [fetchClientFolders.rejected]: (state, action) => {
      state.fetching = false;
      state.fetchError = action.payload.error;
    },
    [fetchClientPhotos.pending]: (state) => {
      state.fetching = true;
    },
    [fetchClientPhotos.fulfilled]: (state, action) => {
      const { photos, meta } = action.payload;
      state.fetching = false;
      state.meta = meta;
      if (state.pageNumber === 1) {
        state.photos = [...photos];
      } else {
        state.photos = [...state.photos, ...photos];
      }
    },
    [fetchClientPhotos.rejected]: (state, action) => {
      state.fetching = false;
      state.fetchError = action.payload;
    },
    [updateClientPhoto.pending]: (state) => {
      state.fetching = true;
    },
    [updateClientPhoto.fulfilled]: (state, action) => {
      state.fetching = false;
      const updatedPhotos = state.photos.map((photo) => {
        if (photo.id === action.payload.id) {
          return { ...photo, ...action.payload };
        } else {
          return photo;
        }
      });
      state.photos = updatedPhotos;
    },
    [updateClientPhoto.rejected]: (state, action) => {
      state.fetching = false;
      state.fetchError = action.payload.error;
    },

    [verifyAlbumPin.pending]: (state) => {
      state.fetching = true;
    },
    [verifyAlbumPin.fulfilled]: (state) => {
      state.fetching = false;
    },
    [verifyAlbumPin.rejected]: (state, action) => {
      state.fetching = false;
      state.fetchError = action.payload.error;
    },
    [fetchClientVideos.pending]: (state) => {
      state.fetching = true;
    },
    [fetchClientVideos.fulfilled]: (state, action) => {
      state.videos = action.payload;
    },
    [fetchClientVideos.rejected]: (state, action) => {
      state.fetching = false;
      state.fetchError = action.payload.error;
    },
  },
});

export const {
  setFolderTabs,
  setPhotosPageNumber,
  setCurrentClientFolder,
  updateAlbumPin,
  openSelectedPhotosModal,
  updateSelectedPhotoCount,
  setSelectedTab,
} = clientSlice.actions;
